export const compare247 = {
  nav: {
    categories: 'Danh mục',
    compare: 'So sánh',
    blog: 'Kiến thức',
    about: 'Giới thiệu'
  },
  hero: {
    title: 'So sánh công cụ số thông minh',
    subtitle: 'Quyết định đúng ngay từ đầu',
    description: 'Compare247 – nền tảng so sánh & tư vấn trung lập 24/7. Không bán hàng, không PR trá hình, chỉ cung cấp thông tin minh bạch để bạn tự quyết định.',
    cta: 'Bắt đầu so sánh',
    searchPlaceholder: 'Tìm kiếm công cụ, nền tảng...'
  },
  categories: {
    title: 'Danh mục so sánh',
    subtitle: 'Chọn lĩnh vực bạn quan tâm',
    ai: {
      title: 'AI & Công nghệ',
      desc: 'So sánh công cụ AI tạo ảnh, video, nội dung và website',
      tools: '50+ công cụ'
    },
    saas: {
      title: 'Phần mềm & SaaS',
      desc: 'CRM, Email marketing, SEO tools và tự động hóa',
      tools: '80+ nền tảng'
    },
    marketing: {
      title: 'Marketing & Quảng cáo',
      desc: 'Công cụ Google Ads, tracking, spy và affiliate',
      tools: '40+ công cụ'
    },
    finance: {
      title: 'Tài chính số',
      desc: 'Sàn crypto, forex, prop trading - đánh giá trung lập',
      tools: '60+ nền tảng'
    },
    platform: {
      title: 'Nền tảng số',
      desc: 'Freelancer, làm việc từ xa, lưu trữ đám mây',
      tools: '35+ nền tảng'
    },
    hosting: {
      title: 'Website & Hosting',
      desc: 'Hosting, VPS, Domain và Website builder',
      tools: '45+ dịch vụ'
    }
  },
  usp: {
    title: 'Tại sao chọn Compare247',
    neutral: {
      title: 'Trung lập tuyệt đối',
      desc: 'Không thiên vị, không thao túng đánh giá. Chỉ cung cấp thông tin khách quan dựa trên nghiên cứu thực tế.'
    },
    transparent: {
      title: 'Minh bạch 100%',
      desc: 'Công khai nguồn thu từ affiliate. Không ưu tiên nền tảng trả hoa hồng cao hơn.'
    },
    noPromise: {
      title: 'Không cam kết lợi nhuận',
      desc: 'Không hứa hẹn kiếm tiền nhanh. Chỉ giúp bạn hiểu rõ và tự đưa ra quyết định phù hợp.'
    },
    support: {
      title: 'Hỗ trợ 24/7',
      desc: 'Luôn cập nhật thông tin mới nhất. Đội ngũ nghiên cứu làm việc liên tục để mang đến dữ liệu chính xác.'
    }
  },
  featured: {
    title: 'So sánh nổi bật',
    subtitle: 'Các bảng so sánh được quan tâm nhiều nhất',
    viewComparison: 'Xem so sánh',
    platforms: 'nền tảng'
  },
  howItWorks: {
    title: 'Cách chúng tôi đánh giá',
    subtitle: 'Quy trình nghiên cứu và so sánh của Compare247',
    step1: {
      title: 'Nghiên cứu sâu',
      desc: 'Đội ngũ chuyên gia nghiên cứu kỹ lưỡng từng nền tảng: tính năng, giá cả, chính sách, đánh giá người dùng thực tế.'
    },
    step2: {
      title: 'Thử nghiệm thực tế',
      desc: 'Trải nghiệm trực tiếp các công cụ, kiểm tra hiệu suất, độ ổn định và chất lượng hỗ trợ khách hàng.'
    },
    step3: {
      title: 'Phân tích khách quan',
      desc: 'So sánh dựa trên tiêu chí rõ ràng: giá trị, tính năng, độ tin cậy, phù hợp với từng đối tượng người dùng.'
    },
    step4: {
      title: 'Cập nhật liên tục',
      desc: 'Theo dõi thay đổi, cập nhật thông tin mới, điều chỉnh đánh giá khi có thay đổi quan trọng từ nền tảng.'
    }
  },
  testimonials: {
    title: 'Người dùng nói gì về Compare247',
    subtitle: 'Phản hồi thực tế từ cộng đồng',
    user1: {
      name: 'Nguyễn Minh Tuấn',
      role: 'Digital Marketer',
      content: 'Compare247 giúp tôi tiết kiệm hàng giờ nghiên cứu. Thông tin rõ ràng, không phóng đại, rất hữu ích khi chọn công cụ marketing.'
    },
    user2: {
      name: 'Trần Thị Hương',
      role: 'Freelancer',
      content: 'Tôi đánh giá cao sự trung lập của Compare247. Không thấy họ cố gắng bán hàng, chỉ cung cấp thông tin để tôi tự quyết định.'
    },
    user3: {
      name: 'Lê Văn Đức',
      role: 'Trader',
      content: 'Phần so sánh prop trading firm rất chi tiết và khách quan. Giúp tôi tránh được những nền tảng không uy tín.'
    }
  },
  stats: {
    platforms: {
      number: '300+',
      label: 'Nền tảng được so sánh'
    },
    comparisons: {
      number: '150+',
      label: 'Bảng so sánh chi tiết'
    },
    users: {
      number: '50K+',
      label: 'Người dùng tin tưởng'
    },
    updates: {
      number: '24/7',
      label: 'Cập nhật liên tục'
    }
  },
  cta: {
    title: 'Sẵn sàng tìm công cụ phù hợp',
    subtitle: 'Bắt đầu so sánh ngay hôm nay và đưa ra quyết định thông minh',
    button: 'Khám phá ngay',
    note: 'Miễn phí, không cần đăng ký'
  },
  footer: {
    tagline: 'Nền tảng so sánh công cụ số trung lập 24/7. So sánh – Hiểu – Tự quyết định.',
    categories: 'Danh mục',
    company: 'Công ty',
    legal: 'Pháp lý',
    contact: 'Liên hệ',
    about: 'Giới thiệu',
    mission: 'Sứ mệnh',
    team: 'Đội ngũ',
    blog: 'Blog',
    privacy: 'Chính sách bảo mật',
    terms: 'Điều khoản sử dụng',
    disclaimer: 'Tuyên bố miễn trừ',
    affiliate: 'Tiết lộ Affiliate',
    email: 'Email',
    phone: 'Điện thoại',
    copyright: '© 2025 Compare247. Bảo lưu mọi quyền.',
    poweredBy: 'Được xây dựng bởi Readdy'
  },
  disclaimer: {
    title: 'Tuyên bố quan trọng',
    affiliate: {
      title: 'Tiết lộ Affiliate',
      content: 'Compare247 có thể nhận hoa hồng khi bạn đăng ký hoặc mua sản phẩm qua liên kết của chúng tôi. Tuy nhiên, điều này không ảnh hưởng đến đánh giá của chúng tôi. Chúng tôi cam kết duy trì tính trung lập và minh bạch trong mọi so sánh.'
    },
    noGuarantee: {
      title: 'Không cam kết lợi nhuận',
      content: 'Compare247 không đảm bảo bất kỳ kết quả tài chính nào từ việc sử dụng các công cụ hoặc nền tảng được đề cập. Mọi quyết định đầu tư hoặc sử dụng dịch vụ là trách nhiệm của bạn.'
    },
    risk: {
      title: 'Cảnh báo rủi ro',
      content: 'Giao dịch tài chính, đầu tư crypto, forex và các sản phẩm tài chính khác có rủi ro cao. Bạn có thể mất toàn bộ số vốn đầu tư. Hãy nghiên cứu kỹ và chỉ đầu tư số tiền bạn có thể chấp nhận mất.'
    },
    accuracy: {
      title: 'Độ chính xác thông tin',
      content: 'Chúng tôi cố gắng cập nhật thông tin chính xác nhất, nhưng các nền tảng có thể thay đổi chính sách, giá cả mà không báo trước. Vui lòng kiểm tra thông tin trực tiếp từ nhà cung cấp trước khi quyết định.'
    }
  }
};
